import { createContext, useContext } from 'react';

interface NethoneContext {
  attemptReference: Promise<string | null>;
}

export const NethoneContext = createContext<NethoneContext | null>(null);

export const useNethoneContext = () => useContext(NethoneContext)!;
